import { Controller } from "@hotwired/stimulus";
import jquery from "jquery";

const DEFAULT_BOOTSTRAP_MODAL_Z_INDEX = 1041;

// Bootstrap is bound to the webpack jQuery in the back-office and to window.$
// (Sprockets) in the front-office. We pick the instance that exposes .modal.
const $ = jquery(".modal").modal ? jquery : window.$;

export default class extends Controller {
  connect() {
    /* Bootstrap does not currently support the opening of several modals (one modal on another one) */
    /* Thus we need to manually handle z-index between the different modals */
    /* Here is a snippet found through https://stackoverflow.com/questions/19305821/multiple-modals-overlay */
    $(".modal").on("show.bs.modal", (e) => {
      const zIndex = this._currentZIndex();
      e.currentTarget.style.zIndex = zIndex;
      setTimeout(() => {
        this._lastBackdrop().style.zIndex = zIndex - 1;
      }, 0);
    });
  }

  _currentZIndex() {
    const numberOfVisibleModals = $(".modal:visible").length;
    return DEFAULT_BOOTSTRAP_MODAL_Z_INDEX + numberOfVisibleModals;
  }

  _lastBackdrop() {
    return document.querySelector(".modal-backdrop:last-of-type");
  }
}
